/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { withHousehold } from 'Context/HouseholdContext';
import Select from 'Components/UI/BehavioralFormElement/Select';

import './index.css';

const timeZoneList = [
  {
    id: 'America/New_York',
    value: 'Eastern',
  },
  {
    id: 'America/Chicago',
    value: 'Central',
  },
  {
    id: 'America/Denver',
    value: 'Mountain',
  },
  {
    id: 'America/Los_Angeles',
    value: 'Pacific',
  },
  {
    id: 'America/Anchorage',
    value: 'Alaska',
  },
  {
    id: 'Pacific/Honolulu',
    value: 'Hawaii',
  },
  {
    id: 'America/Phoenix',
    value: 'Arizona',
  },
];

class TimeZoneSelector extends Component {
  constructor(props) {
    super(props);

    this.onUpdate = this.onUpdate.bind(this);
    this.getClock = this.getClock.bind(this);
    const {
      SimpleHouseholdContext: { householdResource },
    } = props;
    this.state = {
      timeZone: householdResource?.attr('timeZone'),
      hover: false,
    };
  }

  componentDidMount() {
    this.interval = setInterval(
      () => this.setState({ time: Date.now() }),
      5000,
    );
  }

  componentDidUpdate(prevProps) {
    const {
      SimpleHouseholdContext: prevSimpleHouseholdContext,
    } = prevProps;
    const {
      SimpleHouseholdContext,
    } = this.props;

    const { householdResource: prevHouseholdResource } = prevSimpleHouseholdContext;
    const { householdResource } = SimpleHouseholdContext;

    const isNewHousehold = householdResource?.id() !== prevHouseholdResource?.id();

    if (isNewHousehold) {
      this.setTimeZone(householdResource.attr('timeZone'));
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  onUpdate(name, value) {
    const { SimpleHouseholdContext } = this.props;
    const { updateHousehold, householdResource } = SimpleHouseholdContext;

    const updatedHouseholdResource = householdResource.copy().attr('timeZone', value);

    this.setTimeZone(updatedHouseholdResource.attr('timeZone'));

    return updateHousehold(updatedHouseholdResource.export());
  }

  getClock() {
    const { timeZone } = this.state;
    return (timeZone ? moment().tz(timeZone) : moment()).format('h:mm A');
  }

  setTimeZone(timeZone) {
    this.setState({ timeZone });
  }

  render() {
    const { onUpdate } = this;
    const { timeZone, hover } = this.state;
    const clock = this.getClock();
    const displayList = [
      {
        id: '',
        value: timeZone
          ? `Client's local time is ${clock}`
          : 'Assign Time Zone',
      },
    ].concat(timeZoneList);
    return (
      <Select
        className="TimeZoneSelector"
        options={displayList}
        name="timeZone"
        value={hover ? timeZone : ''}
        onChange={onUpdate}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      />
    );
  }
}

TimeZoneSelector.propTypes = {
  SimpleHouseholdContext: PropTypes.object.isRequired,
};

export default withHousehold(TimeZoneSelector);
